import { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { getFaqApiUrl } from '../config/globalConfig';

const decodeHtml = (html) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

export default function MiniFaq() {
    const [activeFaq, setActiveFaq] = useState(1); // Start with first FAQ active
    const [faqItems, setFaqItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchFaqs();
    }, []);

    const fetchFaqs = async () => {
        try {
            setLoading(true);
            const API_URL = getFaqApiUrl('GET_ALL');
            const response = await fetch(API_URL);
            const data = await response.json();
            
            if (data.result && data.Faqs) {
                // Take only the first 4 FAQs and map the data
                const firstFourFaqs = data.Faqs
                    .slice(0, 4)
                    .map((faq, index) => ({
                        id: faq.id,
                        question: faq.title,
                        answer: faq.content
                    }));
                setFaqItems(firstFourFaqs);
            } else {
                setError('No FAQs found');
            }
        } catch (err) {
            console.error('Error fetching FAQs:', err);
            setError('Failed to load FAQs');
            // Fallback to static FAQs if API fails
            setFaqItems([
                {
                    id: 1,
                    question: "What is the minimum age to join the academy?",
                    answer: "We accept students from 5 years and above. Certain advanced courses may have age or skill prerequisites."
                },
                {
                    id: 2,
                    question: "Are the classes online or offline?",
                    answer: "We offer both online and offline classes depending on the course and location."
                },
                {
                    id: 3,
                    question: "How long is each session?",
                    answer: "Sessions are 50–60 minutes."
                },
                {
                    id: 4,
                    question: "Do I need to own an instrument to join?",
                    answer: "For instrumental courses, having your own instrument is mandatory to learn the instrument and for self practice."
                }
            ]);
        } finally {
            setLoading(false);
        }
    };

    // Handle FAQ item click
    const handleFaqClick = (faqId) => {
        // Toggle open/close
        setActiveFaq(activeFaq === faqId ? null : faqId);
    };

    if (loading) {
        return (
            <section id="faq-section">
                <div className="faq-container">
                    <div className="faq-header">
                        <h2 className="section-title">Frequently Asked Questions</h2>
                        <p className="section-subtitle">Find answers to common questions about our music school</p>
                    </div>
                    <div className="loading-state">
                        <p>Loading FAQs...</p>
                    </div>
                </div>
            </section>
        );
    }

    if (error) {
        return (
            <section id="faq-section">
                <div className="faq-container">
                    <div className="faq-header">
                        <h2 className="section-title">Frequently Asked Questions</h2>
                        <p className="section-subtitle">Find answers to common questions about our music school</p>
                    </div>
                    <div className="error-state">
                        <p>{error}</p>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <>
            <section id="faq-section">
                <div className="faq-container">
                    <div className="faq-header">
                        <h2 className="section-title">Frequently Asked Questions</h2>
                        <p className="section-subtitle">Find answers to common questions about our music school</p>
                    </div>

                    <div className="faq-content">
                        {faqItems.map((faq) => (
                            <div
                                key={faq.id}
                                className={`faq-item ${activeFaq === faq.id ? 'active' : ''}`}
                                data-faq={faq.id}
                                onClick={() => handleFaqClick(faq.id)}
                            >
                                <div className="faq-question">
                                    <h3 className="question-text">{faq.question}</h3>
                                    <div className="faq-icon">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M6 9l6 6 6-6" />
                                        </svg>
                                    </div>
                                </div>
                                <div className="faq-answer" dangerouslySetInnerHTML={{ __html: decodeHtml(faq.answer) }} />
                            </div>
                        ))}
                    </div>

                    <div className="faq-cta">
                        <Link to="/faq" className="view-all-faqs-btn">View All</Link>
                    </div>
                </div>
            </section>
        </>
    );
} 